function stopAnimation(animation, needsCommit = true) {
    if (!animation || animation.playState === "finished")
        return;
    // Suppress error thrown by WAAPI
    try {
        if (animation.stop) {
            animation.stop();
        }
        else {
            needsCommit && animation.commitStyles();
            animation.cancel();
        }
    }
    catch (e) { }
}

export { stopAnimation };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/dom/dist/animate/utils/stop-animation.es.js
// module id = yXZf
// module chunks = 0